var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformanceUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.18086 9.33266C4.1733 9.28678 4.17079 9.2409 4.17079 9.19502V2.46714L4.08769 2.63836C4.0046 2.8051 3.8913 2.9573 3.75407 3.08711L1.44644 5.28496C1.15689 5.5748 0.689811 5.62406 0.341084 5.40024C-0.0303031 5.14174 -0.110863 4.64373 0.161068 4.28899C0.183729 4.26101 0.207639 4.23416 0.232817 4.20842L4.40496 0.233467C4.72977 -0.077636 5.25852 -0.0776354 5.58458 0.232349L9.75671 4.20842C10.0815 4.51953 10.0815 5.02199 9.75419 5.33197C9.72901 5.35659 9.70132 5.3801 9.67362 5.40024C9.32364 5.62406 8.85783 5.5748 8.56702 5.28496L6.25685 3.09159C6.13348 2.97408 6.0315 2.84091 5.95218 2.69319L5.83888 2.45483V9.15137C5.85525 9.5576 5.55688 9.91347 5.13891 9.98957C4.68318 10.0601 4.25514 9.76575 4.18086 9.33266Z",
    fill: "#1D8E3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceUp);
export default __webpack_public_path__ + "static/media/PerformanceUp.40cb58c3fc89968788ff9f7d04cadde2.svg";
export { ForwardRef as ReactComponent };